<template>
  <div class="tw-flex tw-h-screen tw-flex-col">
    <!-- Mobile layout -->
    <div class="tw-flex tw-h-full tw-flex-col sm:tw-hidden">
      <!-- Fixed CaseWise logo header -->
      <div :class="headerNav" class="safe-area-top">
        <div
          v-if="cobrandedExperience"
          class="tw-flex tw-w-full tw-items-center tw-justify-center tw-py-4"
        >
          <CaseWiseHeaderLogo />
        </div>
      </div>

      <!-- Scrollable content -->
      <div ref="scrollContainer" class="tw-h-full tw-flex-1 tw-overflow-auto" :class="headerNav">
        <!-- FORM CONTENT -->
        <div
          :class="{ 'tw-mt-4': $device.isMobile && !cobrandedExperience }"
          class="safe-area-bottom tw-flex tw-h-max tw-min-h-screen tw-grow tw-flex-col tw-rounded-t-[30px] tw-bg-white"
        >
          <!-- LOGO AREA -->
          <div v-if="branding?.id !== '1'" class="tw-pt-8">
            <div class="tw-mx-auto tw-h-[70px] tw-w-full tw-max-w-[200px]">
              <img
                :src="cobrandedLogoUrl"
                :alt="branding.name"
                class="tw-h-full tw-w-full tw-object-contain"
              />
            </div>
          </div>

          <!-- CONTENT -->
          <div class="tw-flex tw-h-full tw-grow tw-px-6 tw-pb-10 tw-pt-6">
            <slot />
          </div>
        </div>
        <!-- FOOTER BELOW FORM CONTAINER -->
        <SiteFooter :theme="authFooter" class="safe-area-bottom sm:tw-hidden" />
      </div>
    </div>

    <!-- Desktop and tablet layout -->
    <div class="tw-hidden tw-h-full tw-w-full tw-flex-col sm:tw-flex">
      <!-- Left side - Branding -->

      <div class="tw-flex tw-w-full tw-grow">
        <div
          class="tw-flex tw-h-full tw-w-1/2 tw-flex-col tw-items-center tw-justify-center tw-bg-gradient-to-t"
          :class="[cobrandedExperience ? linearGradient : 'tw-bg-white']"
        >
          <Component
            :is="cobrandedExperience ? CaseWiseLoginLogo : 'img'"
            :src="!cobrandedExperience ? cobrandedLogoUrl : undefined"
            :alt="cobrandedExperience ? branding.name : 'CaseWise'"
            class="tw-h-auto tw-w-[256px] lg:tw-w-[430px] lg:tw-max-w-[430px]"
          />
        </div>

        <!-- Right side - Auth components -->
        <div
          class="tw-flex tw-h-full tw-w-1/2 tw-flex-col tw-items-center tw-justify-center tw-bg-gradient-to-t tw-px-6 tw-py-4 lg:tw-px-8 xl:tw-px-24"
          :class="[cobrandedExperience ? 'tw-bg-white' : linearGradient]"
        >
          <div
            class="tw-flex tw-w-full tw-max-w-5xl tw-flex-col tw-gap-6 tw-rounded-xl tw-bg-white tw-p-10"
          >
            <div
              v-if="cobrandedExperience && branding?.id !== '1'"
              class="tw-h-[70px] tw-w-full tw-max-w-[200px]"
            >
              <img
                :src="cobrandedLogoUrl"
                :alt="branding.name"
                class="tw-h-full tw-w-full tw-object-contain tw-object-left"
              />
            </div>
            <slot />
          </div>
        </div>
      </div>

      <SiteFooter :theme="authFooter" />
    </div>

    <AppToast />
    <WhyNeedDrawer v-model:visible="helpDrawerVisible" />
  </div>
</template>

<script setup lang="ts">
import { useScroll } from '@vueuse/core'

import CaseWiseHeaderLogo from '~/assets/icons/CaseWiseHeaderLogo.svg'
import CaseWiseLoginLogo from '~/assets/icons/CaseWiseLoginLogo.svg'

const { getThemeToken, getThemeTokenString } = useTheme()
const authFooter = getThemeToken('auth-footer')
const linearGradient = getThemeToken('linear-gradient')
const headerNav = getThemeTokenString('header-nav')
const { visible: helpDrawerVisible } = useHelpDrawer()

const branding = useBrand()
const cobrandedExperience = computed(() => branding.value.brandingExperience === 'cobrand')

const cobrandedLogoUrl = computed(() => {
  return branding.value.svgLogoUrl || branding.value.pngLogoUrl
})

const scrollContainer = ref<HTMLElement>()
const route = useRoute()

const { y } = useScroll(scrollContainer, { behavior: 'smooth' })

watch(
  () => route.fullPath,
  () => {
    y.value = 0
  },
  { immediate: true },
)
</script>

<style scoped>
.safe-area-top {
  padding-top: calc(env(safe-area-inset-top) - 12px);
}

.safe-area-bottom {
  padding-bottom: calc(env(safe-area-inset-bottom) / 3);
}
</style>
